module.exports = __webpack_public_path__ + "img/KinokoTable06.ad476edb.jpg";